import React from 'react';
import PropTypes from 'prop-types';

const WithHover = (WrappedComponent) => {
  class WrappedComponentWithHover extends React.Component {
    constructor(props) {
      super(props);
      this.onMouseOver = this.onMouseOver.bind(this);
      this.onMouseOut = this.onMouseOut.bind(this);
      this.state = {
        hover: false,
      };
    }

    onMouseOver() {
      this.setState({ hover: true });
      if (this.props.onMouseOver) {
        this.props.onMouseOver();
      }
    }

    onMouseOut() {
      this.setState({ hover: false });
      if (this.props.onMouseOut) {
        this.props.onMouseOut();
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          isHover={this.state.hover}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
        />
      );
    }
  }

  WrappedComponentWithHover.defaultProps = {
    onMouseOut: () => {},
    onMouseOver: () => {},
  };
  WrappedComponentWithHover.propTypes = {
    onMouseOut: PropTypes.func,
    onMouseOver: PropTypes.func,
  };

  return WrappedComponentWithHover;
};

export default WithHover;



// WEBPACK FOOTER //
// ./src-react/WithHover/index.jsx